import { HiOutlineDownload } from "react-icons/hi";
import React, { useEffect, useState } from "react";
import { BsEye, BsListUl, BsWhatsapp } from "react-icons/bs";
import {
  AiOutlineSearch,
  AiOutlineDownload,
  AiOutlineArrowLeft,
} from "react-icons/ai";
import {
  LoadingOutlined,
  MailOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Typography,
  Input,
  Row,
  Col,
  Table,
  Modal,
  message,
  TablePaginationConfig,
  Tooltip,
  Checkbox,
  Switch,
  Select,
  Dropdown,
  MenuProps,
} from "antd";
import api from "../../services/api";
import Button from "../../components/Button";
import { getTooltipMessage } from "./tooltip";
import apiBolsa from "../../services/bolsa-api";
import { useAuth } from "../../contexts/AuthContext";
import { OperationModal } from "../../components/OperationModal";
import { IClient, useClients } from "../../contexts/ClientsContext";
import { ReactComponent as SendIcon } from "../../assets/icons/send.svg";
import { ReactComponent as DenyIcon } from "../../assets/icons/XRed.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filtro.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/CheckGreen.svg";
import {
  Container,
  Content,
  DarfAutomaticoContainer,
  DropdownButton,
} from "./styles";
import {
  formatCurrency,
  formatCurrencySmart,
  getBrowser,
  isMobile,
  maskCpf,
  monthsExtended,
  isAntesTerceiroDiaUtil,
  thirdBusinessDayAndMonth,
} from "../../utils";
import { SendDarfModal } from "../../components/Darf/SendDarfModal";
import { yearConfigPL4173 } from "../../constants/others/exterior";

interface IFilters {
  text: string;
  value: number;
}

export const dayFilters: Array<IFilters> = [];
for (let d = 1; d <= 31; d++) {
  dayFilters.push({
    text: d.toString(),
    value: d,
  });
}

export const monthFilters: Array<IFilters> = monthsExtended.map((m, i) => ({
  text: m,
  value: i + 1,
}));
export const yearFilters: Array<IFilters> = [];
for (let y = 2020; y <= 2025; y++) {
  yearFilters.push({
    text: y.toString(),
    value: y,
  });
}

const monthsOrder = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
];

var debounce: NodeJS.Timeout;

const tooltip: any = () => (
  <p
    style={{
      margin: "15px",
      fontSize: "13px",
      display: "flex",
      textAlign: "center",
    }}
  >
    O usuário já possui uma conta cadastrada na plataforma. Enviamos um e-mail
    solicitando a sua permissão de acesso à conta e estamos aguardando a
    confirmação do usuário.
  </p>
);

const initialData = {
  year: 2025
}

export const Darfs: React.FC = () => {
  const { user, getUserInfo } = useAuth();
  const {
    loadingGet,
    setLoadingGet,
    darfs,
    getClients,
    totalDarfs,
    handleDownloadSheet,
  } = useClients();

  const [loading, setLoading] = useState(false);
  const [keys, setKeys] = useState<string[]>([]);
  const [filters, setFilters] = useState<any>({ year: [initialData.year] });
  const [searchText, setSearchText] = useState("");
  const [emailFlow, setEmailFlow] = useState(false);
  const [sendToResp, setSendToResp] = useState(false);
  const [whatsappFlow, setWhatsappFlow] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [appliedFilters, setAppliedFilters] = useState<any>({ year: [initialData.year] });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showSendDarfModal, setShowSendDarfModal] = useState(false);
  const [clientsSelected, setClientsSelected] = useState<IClient[]>([]);
  const [allDarfsSelected, setAllDarfsSelected] = useState(false);
  const [modalOperationsOpen, setModalOperationsOpen] =
    useState<boolean>(false);
  const [whatsappRedirectURL, setWhatsappRedirectURL] = useState<
    string | undefined
  >(undefined);
  const [pagination] = useState<TablePaginationConfig>({
    current: currentPage,
    pageSize: 10,
    defaultPageSize: 10,
    showSizeChanger: false, // mudar para true quando o back estiver aceitando
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const handleDisabled = (item: any) => {
    const codes = (item.code || []).filter(
      (el: any) =>
        el?.escritorioId?.toString() === user?.user?.officeId?.toString() ||
        el?.assessorId?.toString() === user?.user?.assessorId?.toString()
    );
    return !codes.some((el: any) => !!el?.isAuthorized) || false;
  };

  const hasActivePlan = (item: any) => {
    const currentTime = new Date().getTime();
    const planDueDate = item.planDueDate;
    const isDueDateValid = planDueDate && planDueDate > currentTime;
    
    // Situação 1: Contratado via calculadora
    const viaCalculadora = item.hasPlanXp && isDueDateValid;
    
    // Situação 2: Contratado pelo pro via pix ou cartão
    const viaProPixCartao = item.planActive && !item.hasPlanXp && item.planName && isDueDateValid;
    
    // Situação 3: Contratado pelo pro via fatura
    const viaProFatura = item.planActive && item.planName && isDueDateValid;
    
    const result = viaCalculadora || viaProPixCartao || viaProFatura;
    
    return result;
  };

  const shouldBlockDarfSend = (item?: any) => {
    // Se não há item específico, verifica se há DARFs do mês anterior selecionados
    if (!item) {
      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      const currentYear = today.getFullYear();
      
      // Calcula o mês anterior
      let previousMonth = currentMonth - 1;
      let previousYear = currentYear;
      
      if (previousMonth === 0) {
        previousMonth = 12;
        previousYear = currentYear - 1;
      }
      
      // Verifica se há algum DARF do mês anterior nos clientes selecionados
      const hasPreviousMonthDarf = clientsSelected.some((client: any) => 
        client.month === previousMonth && client.year === previousYear
      );
      
      // Só bloqueia se houver DARF do mês anterior e estivermos antes do dia 7
      return hasPreviousMonthDarf && isAntesTerceiroDiaUtil();
    }
    
    // Se há item específico, usa a função thirdBusinessDayAndMonth
    const validation = thirdBusinessDayAndMonth(item);
    
    return validation.disabled;
  };

  const handleSearch = (value: string) => {
    setSearchText(value);
    if (debounce) clearTimeout(debounce);
    debounce = setTimeout(() => {
      getClients({
        ...filters,
        searchText: value,
        page: pagination.current,
        pageSize: pagination.pageSize,
        getAllDarfStatus: true,
        planActive: true,
      });
    }, 1000);
  };

  const handleDarfSend = async (
    sendToWhatsapp?: boolean,
    directDownload?: boolean,
    sendEmail?: boolean,
    inputClients?: Array<any>
  ) => {
    try {
      const clients = (allDarfsSelected && inputClients?.length == 10)
        ? (
            await getClients({
              getAllDarfStatus: true,
              planActive: true,
              year: filters.year,
              processAllClients: true,
            })
          ).clients
        : inputClients && inputClients.length > 0
        ? inputClients 
        : [];

      if (whatsappRedirectURL) {
        window.open(whatsappRedirectURL, "_blank");
        setWhatsappRedirectURL(undefined);
      } else {
        setLoadingGet(true);
        if (sendToWhatsapp) {
          setWhatsappRedirectURL("loading");
        }
        const { data } = await api.post("/darf/send", {
          clients: clients,
          sendEmail,
          sendToResp,
          sendToWhatsapp,
        });
        const phone = clients[0].phone;
        const singleClient = data[0] || {};
        const shortPath = singleClient?.urlDarfBolsa || singleClient?.urlDarfExterior || singleClient?.shortPath;

        const isExterior = singleClient?.type === 'Exterior'
        const oldModel = (singleClient?.year ?? 2023) < yearConfigPL4173
        const darfLabel = isExterior && !oldModel ? 'relatório' : 'DARF' 

        if (shortPath && sendToWhatsapp) {
          const text = `Olá, ${
            singleClient?.name || "Cliente"
          }. Segue seu ${darfLabel} do mês ${singleClient?.month}/${
            singleClient?.year
          }: ${shortPath}`;
          const url = `https://wa.me${
            phone ? `/55${phone}` : ""
          }?text=${text.replaceAll(" ", "%20")}`;
          setWhatsappRedirectURL(undefined);
          window.open(url, "_blank");
        }
        if (!sendToWhatsapp) {
          if (directDownload) {
            if (shortPath) {
              window.open(shortPath);
              message.success("Transferência do DARF realizada");
            } else {
              handleDarfDownload(shortPath);
            }
          } else {
            message.success(`Envio de ${darfLabel}s realizado`);
            setWhatsappRedirectURL(undefined);
          }
        }
        getClients({ ...filters, getAllDarfStatus: true, planActive: true });
      }
      setShowSendDarfModal(false);
      setWhatsappFlow(false);
      setEmailFlow(false);
      setSendToResp(false);
    } catch (error: any) {
      setWhatsappRedirectURL(undefined);
      if (error.message.includes("400")) {
        message.error(
          "É necessário contratar o plano para prosseguir"
        );
      } else {
        message.error("Algo errado aconteceu, tente novamente mais tarde.");
      }
    }
    setLoadingGet(false);
  };

  const handleDarfDownload = async (url?: string, idDarf?: string) => {
    let success = false;
    let downloadUrl = url;
    try {
      setLoadingGet(true);
      
      if (url) {
        // Simula tempo de processamento
        await new Promise(resolve => setTimeout(resolve, 1500));
        success = true;
      } else if (idDarf) {
        const token = localStorage.getItem("@VeloTax:token");
        const { data } = await apiBolsa.get(`/darf/download/${idDarf}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        if (data?.url) {
          downloadUrl = data.url;
          // Simula tempo de processamento
          await new Promise(resolve => setTimeout(resolve, 1500));
          success = true;
        } else {
          message.error("Erro ao obter URL do DARF");
        }
      }
    } catch (error) {
      console.error("Erro ao baixar DARF:", error);
      message.error("Erro ao baixar DARF. Tente novamente mais tarde.");
    } finally {
      setLoadingGet(false);
      if (success && downloadUrl) {
        // Abre o arquivo após o loading terminar
        window.open(downloadUrl);
        message.success("Transferência do DARF realizada");
      }
    }
  };

  useEffect(() => {
    getClients({ getAllDarfStatus: true, planActive: true, year: filters?.year });
  }, [getClients]);

  useEffect(() => {
    if (allDarfsSelected) {
      setKeys((darfs ?? []).map((el) => el.id || ""));
    }
  }, [darfs, allDarfsSelected]);

  const handleSwitchDarfAutomatico = async () => {
    try {
      setLoading(true);
      const { enviarDarfAutomaticamente } = user?.user;
      await api.post(`/darf/enviarDarfAutomaticamente`, {
        enviarDarfAutomaticamente: !enviarDarfAutomaticamente,
      });
      await getUserInfo();
      setLoading(false);
      if (!enviarDarfAutomaticamente) {
        message.success(
          "Os DARFs serão enviados para seus clientes automaticamente"
        );
      } else {
        message.info(
          "Os DARFs não serão mais enviados para seus clientes automaticamente"
        );
      }
    } catch (error) {
      setLoading(false);
      message.error(
        "Não foi possível registrar informação. Tente novamente mais tarde."
      );
    }
  };
  const handleClick = (item: any) => {
    setShowSendDarfModal(true);
    setClientsSelected([item]);
    setKeys([item.id]);
  };

  const Drop = (item: any, index: any, isDisabled: boolean) => {
    const items: MenuProps["items"] = [
      {
        key: 1,
        label: (
          <DropdownButton
            onClick={() => {
              setClientsSelected([item]);
              setModalOperationsOpen(true);
            }}
          >
            <BsEye />
            Ver operações
          </DropdownButton>
        ),
      },
      {
        key: 2,
        label: (
          <DropdownButton
            onClick={() => {
              if (loading) return;
              setClientsSelected([item]);
              if (
                (item.urlDarfExterior ||
                  item.urlDarfBolsa ||
                  item.idDarfBolsa ||
                  item.idDarfExterior) &&
                //@ts-ignore
                item?.darfEnviado
              ) {
                handleDarfDownload(
                  item.type === "Bolsa"
                    ? item.urlDarfBolsa
                    : item.urlDarfExterior,
                  item.type === "Bolsa" ? item.idDarfBolsa : item.idDarfExterior
                );
              } else {
                handleDarfSend(false, true, false, [item]);
              }
            }}
          >
            <HiOutlineDownload />
            Baixar DARF
          </DropdownButton>
        ),
      },
    ];

    const isPlanDisabled = !hasActivePlan(item);
    const isDarfBlocked = shouldBlockDarfSend(item);
    const isButtonDisabled = isDisabled || isPlanDisabled || isDarfBlocked;

    const tooltipTitle = isDarfBlocked
      ? "Aguarde o dia 7, para visualizar seu DARF"
      : isPlanDisabled
      ? "Cliente sem plano ativo. Contrate um plano para enviar DARFs."
      : isDisabled
      ? "Solicite permissão ao usuário"
      : "";

    return (
      <div className="action-btns">
        <Tooltip
          title={tooltipTitle}
          placement="top"
          trigger={isButtonDisabled ? "hover" : "none"}
        >
          <div style={{ display: 'inline-block' }}>
            <Button
              onClick={() => handleClick(item)}
              disabled={isButtonDisabled}
              className="action-btn enviar-darf"
            >
              <SendIcon />
              Enviar DARF
            </Button>
          </div>
        </Tooltip>
        <Dropdown menu={{ items }} trigger={["click"]} placement="bottomRight">
          <Button className="action-btn dots">
            <BsListUl />
          </Button>
        </Dropdown>
      </div>
    );
  };

  return (
    <Container>
      <Content>
        <Row
          align="middle"
          gutter={[16, { xs: 16, sm: 32 }]}
          style={{ position: "relative" }}
        >
          <Col span={24}>
            <Typography.Title level={1} className="app-title">
              Impostos devidos
            </Typography.Title>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 16]} align="middle" justify="space-between">
              <Col {...(isMobile() ? { xs: 24 } : {})}>
                <Row gutter={[16, 16]} align="middle">
                  <Tooltip
                    title={
                      shouldBlockDarfSend()
                        ? "Aguarde o dia 7, para visualizar seu DARF"
                        : !clientsSelected || clientsSelected.length === 0
                        ? "Selecione seus clientes para enviar DARFs em lote"
                        : ""
                    }
                  >
                    <Col {...(isMobile() ? { xs: 24 } : {})}>
                      <Button
                        block
                        size="large"
                        type="primary"
                        icon={<SendIcon className="send-icon" />}
                        onClick={() => setShowSendDarfModal(true)}
                        disabled={
                          shouldBlockDarfSend() || 
                          !clientsSelected || 
                          clientsSelected.length === 0
                        }
                      >
                        Enviar DARFs
                      </Button>
                    </Col>
                  </Tooltip>
                  <Col {...(isMobile() ? { xs: 24 } : {})}>
                    <Button
                      block
                      size="large"
                      type="ghost"
                      className="downloadSheet"
                      icon={<AiOutlineDownload />}
                      disabled={darfs.length === 0}
                      onClick={() => handleDownloadSheet("DARFs", filters)}
                    >
                      Baixar planilha
                    </Button>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row gutter={[16, 16]} align="middle">
                  <Col {...(isMobile() ? { xs: 24 } : {})}>
                    <Button
                      block
                      size="large"
                      type="ghost"
                      icon={<FilterIcon />}
                      onClick={() => setShowFilterModal(true)}
                      className={
                        Object.keys(appliedFilters).filter(
                          (key) => (appliedFilters[key]?.length || 0) > 0
                        ).length > 1
                          ? "btn-filter filtro-aplicado"
                          : "btn-filter"
                      }
                    >
                      Filtrar clientes
                    </Button>
                  </Col>
                  <Col {...(isMobile() ? { xs: 24 } : {})}>
                    <Input
                      size="large"
                      placeholder="Buscar cliente"
                      style={{ minWidth: "300px" }}
                      prefix={<AiOutlineSearch size={20} />}
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Table
              rowKey="id"
              loading={loadingGet}
              dataSource={darfs}
              pagination={{
                defaultPageSize: 10,
                total: totalDarfs,
                defaultCurrent: 1,
                simple: true,
                current: currentPage,
              }}
              rowSelection={{
                selectedRowKeys: keys,
                onChange: (_: any, selectedRows, info) => {
                  if (info?.type === "all" && selectedRows?.length) {
                    setAllDarfsSelected(true);
                  } else setAllDarfsSelected(false);
                  setClientsSelected(selectedRows);
                  setKeys((selectedRows ?? []).map((el) => el.id || ""));
                },
                getCheckboxProps: (record: any) => ({
                  disabled: handleDisabled(record),
                }),
              }}
              onChange={(pagination, body, sorter) => {
                const order: any = sorter;
                setCurrentPage(pagination.current ?? 1);
                setFilters(filters);
                setAppliedFilters(filters);
                getClients({
                  searchText,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                  month: filters.month || [],
                  year: filters.year || [2023],
                  type: filters.type || [],
                  planActive: true,
                  impostoDevido: (filters.impostoDevido || [])[0],
                  darfEnviado: (filters.darfEnviado || [])[0],
                  darfPago: (filters.darfPago || [])[0],
                  orderBy: order?.field || undefined,
                  orderDirection: order?.order || undefined,
                  getAllDarfStatus: true,
                });
              }}
              locale={{
                filterReset: "Limpar",
              }}
              columns={[
                {
                  title: "Dados do cliente",
                  sorter: (a, b) => a.name.localeCompare(b.name),
                  render: (_, item) => (
                    <>
                      <Row>
                        <Col
                          span={24}
                          style={{ color: "black", fontWeight: 500 }}
                        >
                          {item.name}
                        </Col>
                      </Row>
                      <Row>
                        <Col span={21} style={{ whiteSpace: "nowrap" }}>
                          {maskCpf(item.username)}
                        </Col>
                        {handleDisabled(item) && (
                          <Col span={1}>
                            <Tooltip title={tooltip}>
                              <InfoCircleOutlined />
                            </Tooltip>
                          </Col>
                        )}
                      </Row>
                      {/* <Row>
                        <Col span={24}>{item.email}</Col>
                      </Row>
                      <Row>
                        <Col span={24}>{numberToPhone(item.phone || "")}</Col>
                      </Row> */}
                    </>
                  ),
                },
                {
                  align: "center",
                  title: "Mês",
                  dataIndex: "month",
                  sorter: (a: any, b: any) =>
                    monthsOrder.indexOf(a.month) - monthsOrder.indexOf(b.month),
                  render: (_, data) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span style={{ marginRight: "4px" }}>
                          {monthsExtended[Number(data.month) - 1]}
                        </span>
                      </div>
                    );
                  },
                },
                {
                  align: "center",
                  title: "Ano",
                  dataIndex: "year",
                  sorter: (a: any, b: any) => a.year - b.year,
                  render: (_, data) => {
                    return (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <span style={{ marginRight: "4px" }}>{data.year}</span>
                      </div>
                    );
                  },
                },
                {
                  align: "center",
                  title: "Mercado",
                  dataIndex: "type",
                  sorter: (a: any, b: any) => a.type.localeCompare(b.type),
                  render: (type, record) => <div>{type}</div>,
                },
                {
                  align: "center",
                  title: "Valor principal",
                  dataIndex: "impostoDevido",
                  sorter: (a: any, b: any) => a.impostoDevido - b.impostoDevido,
                  render: (impostoDevido, record) => (
                    <div>
                      {impostoDevido < 10
                        ? "Não há impostos"
                        : formatCurrencySmart(Number(impostoDevido))}
                    </div>
                  ),
                },
                {
                  align: "center",
                  title: "Enviado?",
                  dataIndex: "darfEnviado",
                  sorter: (a: any, b: any) =>
                    a.darfEnviado === b.darfEnviado
                      ? 0
                      : a.darfEnviado
                      ? -1
                      : 1,
                  render: (darfEnviado, record) => {
                    return (
                      <div className="calc-status">
                        {(record?.impostoDevido || 0) < 10 ? (
                          "N/A"
                        ) : (
                          <>
                            {darfEnviado ? <CheckIcon /> : <DenyIcon />}
                            {darfEnviado ? "Sim" : "Não"}
                          </>
                        )}
                      </div>
                    );
                  },
                },
                {
                  align: "center",
                  title: "Pago?",
                  dataIndex: "darfPago",
                  sorter: (a: any, b: any) =>
                    a.darfPago === b.darfPago ? 0 : a.darfPago ? -1 : 1,
                  render: (darfPago, record) => {
                    return (
                      <div className="calc-status">
                        {(record?.impostoDevido || 0) < 10 ? (
                          "N/A"
                        ) : (
                          <>
                            {darfPago ? <CheckIcon /> : <DenyIcon />}
                            {darfPago ? "Sim" : "Não"}
                          </>
                        )}
                      </div>
                    );
                  },
                },
                {
                  title: "",
                  dataIndex: "orderBy",
                  render: (_, item, index) =>
                    Drop(
                      item,
                      index,
                      Number(item.impostoDevido || 0) < 10 ||
                        handleDisabled(item)
                    ),
                },
              ]}
            />
          </Col>
        </Row>
        <SendDarfModal
          showSendDarfModal={showSendDarfModal}
          setShowSendDarfModal={setShowSendDarfModal}
          clientsSelected={clientsSelected}
          setClientsSelected={setClientsSelected}
          sendToResp={sendToResp}
          setSendToResp={setSendToResp}
          whatsappRedirectURL={whatsappRedirectURL}
          setWhatsappRedirectURL={setWhatsappRedirectURL}
        />
        <OperationModal
          modalOperationsOpen={modalOperationsOpen}
          setModalOperationsOpen={setModalOperationsOpen}
          clientsSelected={clientsSelected}
          handleDarfDownload={handleDarfDownload}
          handleDarfSend={handleDarfSend}
          loadingDownload={loading}
        />
        <Modal
          footer={null}
          open={showFilterModal}
          title="Filtrar clientes 12"
          className="filter-modal"
          onCancel={() => {
            setFilters(appliedFilters);
            setShowFilterModal(false);
          }}
        >
          <Row gutter={[24, 24]}>
            <Col span={12}>
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Typography.Text strong>Mês</Typography.Text>
                </Col>
                <Col span={24}>
                  <Select
                    allowClear
                    size="large"
                    mode="multiple"
                    value={filters.month}
                    placeholder="Selecionar"
                    className="month-select"
                    getPopupContainer={(trigger) => trigger.parentNode}
                    options={monthsExtended.map((m, i) => ({
                      label: m,
                      value: i + 1,
                    }))}
                    onChange={(month) => {
                      setFilters((filters: any) => ({ ...filters, month }));
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Typography.Text strong>Ano</Typography.Text>
                </Col>
                <Col span={24}>
                  <Select
                    allowClear
                    size="large"
                    mode="multiple"
                    value={filters.year}
                    options={yearFilters}
                    placeholder="Selecionar"
                    style={{ width: "100%" }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    onChange={(year) => {
                      setFilters((filters: any) => ({ ...filters, year }));
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Typography.Text strong>Mercado</Typography.Text>
                </Col>
                <Col span={24}>
                  <Checkbox.Group
                    value={filters.type}
                    onChange={(type) => {
                      setFilters((filters: any) => ({
                        ...filters,
                        type,
                      }));
                    }}
                  >
                    <Row gutter={[4, 4]}>
                      <Col span={24}>
                        <Checkbox value="Bolsa">Bolsa</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Exterior">Exterior</Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>
                </Col>
              </Row>
            </Col>
            {/* <Col span={24}>
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Typography.Text strong>Imposto devido</Typography.Text>
                </Col>
                <Col span={24}>
                  <Radio.Group
                    value={filters.impostoDevido}
                    onChange={(event) => {
                      console.log('Teste', event.target.value)
                      setFilters((filters: any) => ({
                        ...filters,
                        impostoDevido: event.target.value,
                      }));
                    }}
                  >
                    <Row gutter={[4, 4]}>
                      <Col span={24}>
                        <Radio value="Impostos devidos">Impostos devidos</Radio>
                      </Col>
                      <Col span={24}>
                        <Radio value="Não há impostos">Não há impostos</Radio>
                      </Col>
                    </Row>
                  </Radio.Group>
                </Col>
              </Row>
            </Col> */}
            <Col span={12}>
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Typography.Text strong>DARF Enviado?</Typography.Text>
                </Col>
                <Col span={24}>
                  <Checkbox.Group
                    value={filters.darfEnviado}
                    onChange={(event) => {
                      setFilters((filters: any) => ({
                        ...filters,
                        darfEnviado: event[0],
                      }));
                    }}
                  >
                    <Row gutter={[4, 4]}>
                      <Col span={24}>
                        <Checkbox value="Sim">Sim</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Não">Não</Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row gutter={[8, 8]}>
                <Col span={24}>
                  <Typography.Text strong>DARF Pago?</Typography.Text>
                </Col>
                <Col span={24}>
                  <Checkbox.Group
                    value={filters.darfPago}
                    onChange={(event) => {
                      setFilters((filters: any) => ({
                        ...filters,
                        darfPago: event[0],
                      }));
                    }}
                  >
                    <Row gutter={[4, 4]}>
                      <Col span={24}>
                        <Checkbox value="Sim">Sim</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Não">Não</Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Button
                block
                size="large"
                type="primary"
                loading={loadingGet}
                onClick={() => {
                  setAppliedFilters(filters);
                  setCurrentPage(1);
                  getClients({
                    searchText,
                    page: 1,
                    pageSize: pagination.pageSize,
                    month: filters.month || [],
                    year: filters.year || [],
                    type: filters.type || [],
                    impostoDevido: "Impostos devidos",
                    planActive: true,
                    darfEnviado: filters.darfEnviado,
                    darfPago: filters.darfPago,
                    orderBy: (filters.orderBy || [])[0],
                    getAllDarfStatus: true,
                  });
                  setTimeout(() => {
                    setShowFilterModal(false);
                  }, 500);
                }}
              >
                Aplicar
              </Button>
              {!!filters.darfEnviado ||
              !!filters.darfPago ||
              !!filters.year ||
              !!filters.type ||
              !!filters.month ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <Button
                    type="link"
                    onClick={() => {
                      setFilters({});
                    }}
                  >
                    Limpar
                  </Button>
                </div>
              ) : null}
            </Col>
          </Row>
        </Modal>
      </Content>
      {/* {(user?.user?.office || user?.user?.admin) && (
        <DarfAutomaticoContainer>
          <Switch
            size="small"
            disabled={loading}
            className="switchDarfAutomatico"
            onChange={handleSwitchDarfAutomatico}
            checked={user?.user?.enviarDarfAutomaticamente}
            checkedChildren={loading ? <LoadingOutlined /> : "on"}
            unCheckedChildren={loading ? <LoadingOutlined /> : "off"}
          />
          Envio automático do DARF
          <Tooltip
            placement="topRight"
            title="É recomendado manter a opção ativada para que seus clientes recebam DARFs sempre que possuírem impostos a pagar"
          >
            <InfoCircleOutlined style={{ marginLeft: "8px" }} />
          </Tooltip>
        </DarfAutomaticoContainer>
      )} */}
    </Container>
  );
};
